module.exports = __webpack_public_path__ + "dashboard-page-c3b4ff22169e9a0d1633e289bbfda262.png";